import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { getDefaultToast, Toast } from '../../services/models/toast.model';
import { CreateToast, RemoveToast } from './toast.actions';
import { append, patch, removeItem } from '@ngxs/store/operators';

export type ToastStateModel = {
  toasts: Toast[];
}

export const initialState: ToastStateModel = {
  toasts: [],
};

@State<ToastStateModel>({
  name: 'toasts',
  defaults: initialState,
})
@Injectable()
export class ToastState {
  @Selector()
  static toasts(state: ToastStateModel) {
    return state.toasts;
  }

  @Action(CreateToast)
  createToast(context: StateContext<ToastStateModel>, { toast }: { toast: Partial<Toast> }) {
    const completeToast = { ...getDefaultToast(), ...toast };
    context.setState(patch({
      toasts: append([completeToast]),
    }));

    setTimeout(() => {
      context.dispatch(new RemoveToast(completeToast.id))
    }, completeToast.timeout);
  }

  @Action(RemoveToast)
  removeToast(context: StateContext<ToastStateModel>, { id }: RemoveToast) {
    context.setState(patch({
      toasts: removeItem((toast) => toast.id === id),
    }));
  }
}
